import { QiraMessage, QiraMessageContentChunk } from 'api3';
import { CommonModule } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { TabService } from '@app/services/tab.service';
import { ModalService } from '@app/components/modal/modal.service';
import { SmartSearchModalComponent } from '../smart-search-modal/smart-search-modal.component';
import { TranslocoPipe } from '@jsverse/transloco';
import { Button } from 'primeng/button';

@Component({
  selector: 'app-smart-search-modal-button',
  templateUrl: './smart-search-modal-button.component.html',
  imports: [Button, TranslocoPipe, CommonModule],
  standalone: true,
})
export class SmartSearchModalButtonComponent {
  content = input.required<QiraMessageContentChunk[] | undefined>();
  tabId = input.required<string | undefined>();
  messageIndex = input.required<number>();
  disabled = input<boolean>(false);

  modalService = inject(ModalService);
  tabService = inject(TabService);

  questionText = computed(() => {
    const tab = this.tabService.getTabById(this.tabId());
    if (tab) {
      const lastQuestion = this._getLastQuestion(tab.messages || [], this.messageIndex() || 0);
      return lastQuestion || '';
    }
    return '';
  });

  openSmartSearchModal() {
    this.modalService.open(
      SmartSearchModalComponent,
      { content: this.content(), tabId: this.tabId(), question: this.questionText() },
      { screen: 'auto', showCloseButton: false },
    );
  }

  private _getLastQuestion(messages: QiraMessage[], answerIndex: number) {
    // run backwards starting from the given index
    for (let i = answerIndex; i >= 0; i--) {
      const message = messages[i];

      if (this.tabService.isChatQuestion(message)) {
        return message.content[0]?.text;
      }
    }

    return undefined;
  }
}
